const scripts = [
  '/static/adaptive-performance.js',
  '/static/reference-background.js',
  '/static/birth-hierarchy.js',
  '/static/birth-hierarchy-extra.js',
  '/static/universe-render-utils.js',
  '/static/galaxy-orbit.js',
  '/static/image-shape-detector.js',
  '/static/exact-effects.js',
  '/static/site.js'
]

export function configureUniverseBody () {
  document.body.dataset.backgroundMode = 'reference-full'
  document.body.dataset.cosmicTheme = 'storm'
  document.body.dataset.cosmicParticles = 'off'
  document.body.dataset.meteorScale = '0.5'
  document.body.dataset.birthChildMode = 'flat'
}

function loadScript (src) {
  const existing = document.querySelector(`script[data-universe-script="${src}"]`)
  if (existing) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.dataset.universeScript = src
    script.onload = resolve
    script.onerror = () => reject(new Error(`Unable to load ${src}`))
    document.body.appendChild(script)
  })
}

export function loadUniverseExperience () {
  return scripts.reduce(
    (chain, src) => chain.then(() => loadScript(src)),
    Promise.resolve()
  ).then(() => {
    destroyUniverseExperience()
    if (typeof window.startUniverseSite !== 'function') {
      throw new Error('Universe site initializer is unavailable')
    }
    window.stopUniverseExperience = window.startUniverseSite()
  })
}

export function destroyUniverseExperience () {
  const stop = window.stopUniverseExperience
  window.stopUniverseExperience = undefined
  if (typeof stop === 'function') stop()
}



// WEBPACK FOOTER //
// ./src/lib/universeExperience.js